import { render, staticRenderFns } from "./ReservationTab.vue?vue&type=template&id=e1a3cb96&scoped=true&"
import script from "./ReservationTab.vue?vue&type=script&lang=js&"
export * from "./ReservationTab.vue?vue&type=script&lang=js&"
import style0 from "./ReservationTab.vue?vue&type=style&index=0&id=e1a3cb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a3cb96",
  null
  
)

export default component.exports